module.exports = __webpack_public_path__ + "static/media/nyc.ccf1b8e4.png";